import { CertBioSuisseResponseDTO, CreateCertBioSuisseDTO, EditCertBioSuisseDTO, GetAllCertificatesFiltersDTO } from "./dto";
import { BioSuisseServiceImpl } from "./serviceImpl";

export interface BioSuisseService {
    GetAllBioSuisse(filters: GetAllCertificatesFiltersDTO): Promise<CertBioSuisseResponseDTO>
    CreateBioSuisse(data: CreateCertBioSuisseDTO): Promise<void>
    UpdateBioSuisse(data: EditCertBioSuisseDTO, id: string): Promise<void>
}

export function NewBioSuisseService(): BioSuisseService {
    return new BioSuisseServiceImpl()
}